import { z } from "zod";

export type SelectionList = z.infer<typeof SelectionListSchema>;
export const SelectionListSchema = z.object({
  label: z.string(),
  payload: z.string(),
});
